import React from 'react';
import './preloader.css';
import Default from './../../assets/images/default.svg';

const Preloader = (props) => {
  let bgTheme = 'light';
  let brandName = '';
  let brandTag = 'Please wait...';
  let loader = Default;
  let mediaDimension = { h: 'auto', w: '100px' };
  let customBg = '';

  return (
    <>
      {bgTheme === 'light' ? (
        <div className='full_page_loading_light'>
          <div className='animation_holder_light'>
            <div className='animation_wrapper_light'>
              <div className='svg_holder'>
                <img src={loader} width={mediaDimension.w} height={mediaDimension.h} />
              </div>
              <div className='brand_name_light'>{brandName}</div>
              <div className='brand_tag_light'>{brandTag}</div>
            </div>
          </div>
        </div>
      ) : bgTheme === 'dark' ? (
        <div className='full_page_loading_dark'>
          <div className='animation_holder_dark'>
            <div className='animation_wrapper_dark'>
              <div className='svg_holder'>
                <img src={loader} width={mediaDimension.w} height={mediaDimension.h} />
              </div>
              <div className='brand_name_dark'>{brandName}</div>
              <div className='brand_tag_dark'>{brandTag}</div>
            </div>
          </div>
        </div>
      ) : (
        <div className='full_page_loading_dark' style={{ backgroundColor: customBg }}>
          <div className='animation_holder_dark'>
            <div className='animation_wrapper_dark'>
              <div className='svg_holder'>
                <img src={loader} width={mediaDimension.w} height={mediaDimension.h} />
              </div>
              <div className='brand_name_dark'>{brandName}</div>
              <div className='brand_tag_dark'>{brandTag}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Preloader;
